import { Entity, Index, PrimaryColumn, Column, BaseEntity } from "typeorm";

@Entity({ name: 'pool_tickets' }) 
@Index(['business_id', 'location_id', 'id'])
@Index(['business_id', 'location_id', 'last_modified'])
@Index(['business_id', 'location_id', 'isSynced'])
@Index(['business_id', 'location_id', 'code'])
export class PoolTicket extends BaseEntity {
  @PrimaryColumn()
  id: string;

  @Column() 
  @Index()
  business_id: string;

  @Column() 
  @Index()
  location_id: string;

  @Column({ nullable: true })
  @Index()
  operator_id: string;

  @Column({ nullable: true })
  @Index()
  customer_id: string;

  @Column({ nullable: true })
  @Index()
  pool_catalogue_id: string;

  @Column() 
  @Index()
  code: string;

  @Column({ type: 'decimal', precision: 26, scale: 8, default: 0.0 })
  amount: string;

  @Column({ type: 'text', nullable: true })
  notes: string;

  @Column({ default: 'unused' })
  status: string;

  @Column({ nullable: true })
  scheduled_at: Date;

  @Column({ nullable: true })
  used_at: Date;

  @Column({ type: 'text', nullable: true })
  metadata: string;

  @Column()
  created_at: Date;

  @Column({ nullable: true })
  updated_at: Date;

  @Column({ type: 'bigint', nullable: true })
  @Index()
  last_modified: number;

  @Column({ default: false })
  @Index()
  isSynced: boolean;
}